import  { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetVerifyUser } from './api/api';
import Loader from '../Loader/buttonLoad';

const AdminUserView = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [tokenReady, setTokenReady] = useState(false);

    const { data: adminVerifyUser } = useGetVerifyUser(tokenReady);

    useEffect(() => {
        if (id) {
            sessionStorage.setItem('user_JWT', id);

            const timer = setTimeout(() => {
                setTokenReady(true);
            }, 3000);

            return () => clearTimeout(timer);
        }
    }, [id]);

    useEffect(() => {
        if (adminVerifyUser) {
            sessionStorage.setItem('role', adminVerifyUser.role);
            sessionStorage.setItem('address',adminVerifyUser?.address)

            window.history.replaceState({}, document.title, "/adminview");

            navigate('/dashboard');
        }
    }, [adminVerifyUser, navigate]);

    return <div><Loader /></div>;
};

export default AdminUserView;